const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function twoDigits(n: number): string {
  if (n < 20) return ones[n];
  return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
}

function threeDigits(n: number): string {
  if (n === 0) return "";
  if (n < 100) return twoDigits(n);
  return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + twoDigits(n % 100) : "");
}

/**
 * Convert a number to Indian English words.
 * e.g. 49302 → "Forty Nine Thousand Three Hundred Two"
 */
export function numberToIndianWords(num: number): string {
  if (num === 0) return "Zero";

  const n = Math.round(Math.abs(num));
  if (n === 0) return "Zero";

  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const remainder = n % 1000;

  const parts: string[] = [];
  if (crore) parts.push(twoDigits(crore) + " Crore");
  if (lakh) parts.push(twoDigits(lakh) + " Lakh");
  if (thousand) parts.push(twoDigits(thousand) + " Thousand");
  if (remainder) parts.push(threeDigits(remainder));

  return parts.join(" ");
}

/**
 * Convert amount to "Rupees ... Only" format.
 * e.g. 49302.00 → "Rupees Forty Nine Thousand Three Hundred Two Only"
 */
export function amountToWords(amount: number): string {
  // Round to whole paise ONCE, then split — so the words match the printed
  // figure (which also rounds to 2 decimals). Splitting first let the paise
  // round up to 100 independently: 1234.999 → rupees 1234 + round(99.9)=100 →
  // "…and One Hundred Paise", while the figure showed 1,235.00. Deriving both
  // from the same rounded total keeps rupees and paise consistent.
  const totalPaise = Math.round(Math.abs(amount) * 100);
  const rupees = Math.floor(totalPaise / 100);
  const paise = totalPaise % 100;

  let result = "Rupees " + numberToIndianWords(rupees);
  if (paise > 0) {
    result += " and " + numberToIndianWords(paise) + " Paise";
  }
  result += " Only";
  return result;
}
